import ApiService from "./index";

const User = {
    login(username, password) {
      let headers = {
        'UserName': username,
        'Password': password,
        'Content-Type': 'application/json',
      }
      return ApiService.post("/api/Systems/LoginAuthenticate", {}, {
        headers: headers
      });
    },
    get(id) {
        return ApiService.get("/api/Systems/UserInformation?id="+id);
    },
    checkExistEmail(email){
      return ApiService.post("/api/Systems/CheckExistEmail", {},{"Email": email});
    },
    checkExistPhone(phone){
      return ApiService.post("/api/Systems/CheckExistPhoneNumber", {},{"Phone": Number(phone)});
    },
    checkExistUserName(username){
      return ApiService.post("/api/Systems/CheckExistUserName", {},{"UserName": username});
    },
    register(body) {
      return ApiService.post("/api/Systems/RegisterPersonal", body);
    },
    changePassword(user, password) {
      return ApiService.post("/api/Systems/ChangePassword", {}, {
        headers: {'userId': user, 'NewPassword': password}
      });
    },
    resetPassword(email) {
      return ApiService.post("/api/Systems/ResetPassword", {'Email': email});
    },
    registerBussiness(body) {
      return ApiService.post("/api/Systems/RegisterBusiness", body);
    },
    refreshToken(){
      return ApiService.get("tags");
    },
    UpdateProfile(body){
      return ApiService.post("/api/Systems/CapNhatTaiKhoan", body)
    },
    UpdateProfileBusiness(body){
      return ApiService.post("/api/Systems/CapNhatTaiKhoanBusiness", body)
    }
};

export default User;


// WEBPACK FOOTER //
// ./src/common/api/user.js